<script lang="ts">
    import { onMount, onDestroy, tick } from 'svelte';
    import * as qs from 'qs';
    import configs from '../../config';

    const DISMISS_KEY = 'pwa_banner_hide_until'
    const DISMISS_MS = 24 * 60 * 60 * 1000   // ปิดแล้วเงียบ 1 วัน แล้วค่อยโชว์ใหม่

    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    let pwaSetting = (dataSetting && dataSetting.pwa) ? dataSetting.pwa : null
    let pwaEnabled = !!(pwaSetting && pwaSetting.enabled)
    let pwaLoading = false
    let bannerEl

    // ไอคอนแอป: ใช้ของ pwa ก่อน (สี่เหลี่ยมจัตุรัส เหมาะกับกรอบมน) ค่อย fallback เป็นโลโก้เว็บ
    let icon = (pwaSetting && (pwaSetting.icon_192 || pwaSetting.apple_icon || pwaSetting.icon_512))
        || (dataSetting && (dataSetting.logo_wallet || dataSetting.logo))
        || ''

    function isDismissed(){
        let until = Number(window.localStorage.getItem(DISMISS_KEY) || 0)
        return until > Date.now()
    }
    let dismissed = isDismissed()
    $: visible = pwaEnabled && !dismissed

    // วัดความสูง banner → ตั้งเป็น CSS var ให้ header sticky มาเกาะใต้ banner พอดี
    function syncBannerHeight(){
        let h = (visible && bannerEl) ? bannerEl.offsetHeight : 0
        document.documentElement.style.setProperty('--pwa-banner-h', h + 'px')
    }
    onMount(async () => {
        await tick()
        syncBannerHeight()
        window.addEventListener('resize', syncBannerHeight)
    })
    // logout → banner ถูกถอดออก ต้องคืนค่า offset ไม่งั้น header sticky ค้างเว้นที่ว่างไว้
    onDestroy(() => {
        window.removeEventListener('resize', syncBannerHeight)
        document.documentElement.style.setProperty('--pwa-banner-h', '0px')
    })

    async function onDismiss(){
        dismissed = true
        try{ window.localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_MS)) }catch(err){ /* ignore */ }
        // banner หายแล้ว → ต้องคืน offset ให้ header เอง (component ยังไม่ถูก destroy)
        await tick()
        syncBannerHeight()
    }

    async function onClickInstall(){
        if(pwaLoading){ return }
        pwaLoading = true
        try{
            const res = await fetch(configs.cloudapi+"/cloud/pwadomain", {
                method: 'POST',
                headers:{ 'Content-Type': 'application/x-www-form-urlencoded' },
                body: qs.stringify({})
            })
            const json = await res.json()
            if(json.statusCode==200 && json.payload && json.payload.url){
                window.location.href = json.payload.url
                return
            }else{
                alert(json.message || 'ไม่สามารถเปิดหน้าติดตั้ง PWA ได้')
            }
        }catch(err){
            alert('เกิดข้อผิดพลาด ลองใหม่อีกครั้ง')
        }
        pwaLoading = false
    }
</script>

{#if visible}
<div class="pwa-banner" bind:this={bannerEl}>
    <button class="pwa-close" type="button" aria-label="ปิด" on:click={onDismiss}>
        <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
            <path d="M5 5 L19 19 M19 5 L5 19" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" fill="none"/>
        </svg>
    </button>

    {#if icon}
        <img class="pwa-icon" src={icon} alt="" on:error={() => icon = ''} />
    {/if}

    <div class="pwa-text">
        <div class="pwa-title">ดาวน์โหลดแอป</div>
        <div class="pwa-sub">ติดตั้งแอปหมุนกงล้อฟรีทุกวัน</div>
    </div>

    <button class="pwa-install" type="button" on:click={onClickInstall} disabled={pwaLoading}>
        {pwaLoading ? 'กำลังเปิด...' : 'ติดตั้ง'}
    </button>
</div>
{/if}

<style>
    .pwa-banner{
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        margin: 0 auto;
        padding: 5px 8px;
        background: #0d0d0d;
        border-bottom: 1px solid rgba(255,255,255,.07);
        position: sticky;
        position: -webkit-sticky;
        top: 0;
        z-index: 1001;
        box-sizing: border-box;
    }
    .pwa-close{
        flex: 0 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 22px;
        height: 22px;
        padding: 0;
        border: none;
        background: transparent;
        color: #fff;
        cursor: pointer;
        opacity: .9;
    }
    .pwa-close:hover{ opacity: 1; }
    .pwa-icon{
        flex: 0 0 auto;
        width: 30px;
        height: 30px;
        border-radius: 7px;
        object-fit: cover;
        background: #1a1a1a;
    }
    .pwa-text{
        flex: 1 1 auto;
        min-width: 0;          /* กันชื่อยาวดันปุ่มตกขอบ */
        line-height: 1.25;
    }
    .pwa-title{
        color: #fff;
        font-size: .78rem;
        font-weight: 600;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .pwa-sub{
        color: #b9b9b9;
        font-size: .62rem;
        font-weight: 400;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .pwa-install{
        flex: 0 0 auto;
        padding: 5px 13px;
        border: none;
        border-radius: 6px;
        font-family: inherit;   /* button ไม่ inherit ฟอนต์เอง → ไทยจะตกไปใช้ system font */
        font-size: .72rem;
        font-weight: 600;
        color: #fff;
        background: #22b95c;
        box-shadow: 0 2px 6px rgba(0,0,0,.35);
        cursor: pointer;
        white-space: nowrap;
    }
    .pwa-install:active{ transform: translateY(1px); }
    .pwa-install:disabled{ opacity: .7; cursor: default; }

    /* บน desktop คอลัมน์แอปกว้าง 374px (เหมือน .container) → ให้แถบกว้างเท่ากันและอยู่กลาง */
    @media only screen and (min-device-aspect-ratio:1920 / 1080){
        .pwa-banner{ max-width: 374px; }
    }
    @media only screen and (min-device-aspect-ratio:512/683){
        .pwa-banner{ max-width: 374px; }
    }
</style>
